import { produce } from "immer"
const initalState = {
    data: {
        category: "5",
        type: "",
        social_media: "",
        max_submission: "",
        price: ""

    }
}
const TaskCreatorStepReducer = (state = initalState, action) => {
    switch (action.type) {
        case "ADD_STEP_DATA":
            return produce((state), draft => {
                let obj = { ...action.payload }
                draft.data = obj
            })
        default:
            return state
    }
}
export default TaskCreatorStepReducer